
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/server-sitemap",
      function () {
        return require("private-next-pages/server-sitemap/index.js");
      }
    ]);
  